import axios from "axios";
import Localbase from "localbase";
import ENDPOINT from "../../context/EndPoint";

const LogoutUser = async ({ payload }) => {
  const db = new Localbase();

  try {
    // Delete user data from Localbase before making the request
    // await db.collection("paths").doc("user").delete();

    // Prepare FormData
    const formData = new FormData();
    formData.append("session", payload.session);

    // Send logout request
    const response = await axios.post(`${ENDPOINT}logout.php`, formData);
    const result = response.data;
console.log(result[0])
    if (result[0].status === "loggedout") {
      window.location.replace("/");
      // Clear additional data
      // await db.collection("paths").doc("user").delete();
      // await db.collection("paths").doc("notifications").delete();

      localStorage.setItem("user", null);
      localStorage.setItem("msg", null);
      
      // Redirect to homepage
 
    }
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

export default LogoutUser;
